import React from "react";
import { makeStyles, tokens, Tooltip } from "@fluentui/react-components";

export interface NewformaSharedFolderIconProps {
    className?: string;
    /** Text rendered in the center of the square; useful for shared-storage providers with a short identifier. */
    text?: string;
    /** Optional override for the square background. */
    backgroundColor?: string;
    /** Optional override for the text color. */
    color?: string;
    /** Optional tooltip content displayed on hover. */
    tooltip?: string;
}

const useStyles = makeStyles({
    root: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: "22px",
        height: "21px",
        borderRadius: "4px",
        backgroundColor: `var(--newforma-shared-folder-background, ${tokens.colorPaletteSteelBorderActive})`,
        color: tokens.colorNeutralForegroundOnBrand,
        fontSize: "12px",
        fontWeight: 700,
        lineHeight: 1,
        flexShrink: 0,
        userSelect: "none",
    },
});

export const NewformaSharedFolderIcon: React.FC<NewformaSharedFolderIconProps> = ({
    className,
    text = "S",
    backgroundColor,
    color,
    tooltip,
}) => {
    const styles = useStyles();
    const icon = (
        <span
            className={[styles.root, className].filter(Boolean).join(" ")}
            style={{
                ...(backgroundColor ? { backgroundColor } : {}),
                ...(color ? { color } : {}),
            }}
            role={tooltip ? "img" : undefined}
            aria-label={tooltip ?? text}
            tabIndex={tooltip ? 0 : undefined}
        >
            {text}
        </span>
    );

    if (!tooltip) {
        return icon;
    }

    return (
        <Tooltip content={tooltip} relationship="description" appearance="inverted" withArrow>
            {icon}
        </Tooltip>
    );
};
